package org.koin.ksp.generated

import org.koin.core.module.Module
import org.koin.dsl.*


public val com_essntl_features_message_domain_di_MessageUseCaseModule : Module get() = module {
	single() { _ -> com.essntl.features.message.domain.useCase.CheckSendContactUseCase(messageRepository=get(),toastManager=get()) } 
	single() { _ -> com.essntl.features.message.domain.useCase.SendItineraryMessageUseCase(messageRepository=get(),toastManager=get(),dateFormatUseCase=get()) } 
}
public val com.essntl.features.message.domain.di.MessageUseCaseModule.module : org.koin.core.module.Module get() = com_essntl_features_message_domain_di_MessageUseCaseModule
